export default __webpack_public_path__ + "static/media/top-b-9-thumb.b91e10d0.jpg";